export const PORTAL_NAMES = {
  ACTION: 'action',
  BREADCRUMBS: 'breadcrumbs',
  SEARCH: 'search',
  PRESETS: 'presets',
  FILTERS: 'filters',
  FILTERS_APPLY: 'filtersApply',
  ACTIONS: 'actions',
  SMART_SEARCH: 'smartSearch',
};
